// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import bootstrap from './bootstrap'

bootstrap.config_router()
bootstrap.config_http()
bootstrap.reg_directives()
bootstrap.start()



// WEBPACK FOOTER //
// ./src/main.js